<template>
  <el-menu
    v-bind="$attrs"
    :class="['is-' + menuHeight]"
    :collapse="collapse"
    :unique-opened="uniqueOpened"
    :collapse-transition="collapseTransition"
    :default-active="defaultActive"
    :default-openeds="defaultOpeneds"
    class="rt-menu"
    v-on="$listeners"
  >
    <slot />
  </el-menu>
</template>

<script>
import ElMenu from 'vue-xpc/src/element-ui/packages/menu';
export default {
  name: 'RtMenu',
  components: { ElMenu },
  props: {
    menuHeight: {
      type: String,
      default: 'large',
      validator (v) {
        return v === 'small' || v === 'large' || v === 'medium';
      }
    },
    collapse: {
      type: Boolean
    },
    uniqueOpened: {
      type: Boolean
    },
    collapseTransition: {
      type: Boolean,
      default: true
    },
    defaultActive: {
      type: String,
      default: ''
    },
    defaultOpeneds: {
      type: Array
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtMenu.vue?03c07a29